import {$window, $body, Breakpoints} from '../Constants';
import Nav from './Nav';

/**
 * NavMain
 */
const NavMain = (() => {
	// Constants
	const MOBILE_BREAKPOINT = Breakpoints.X_LARGE;

	/**
	 * Selector
	 */
	const Selector = {
		NAV_MAIN: '.menu-main',
		BACK: '.menu-main-back'
	};

	/**
	 * NavMain
	 *
	 * @class
	 * @augments Nav
	 */
	class NavMain extends Nav {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			const $allLevel2Wrapper = $('.level-2-wrapper');

			this.$element.on('click', Selector.BACK, (e) => {
				const $back = $(e.currentTarget);

				if ($back.parents('.level-3-container').length) {
					const $level3Container = $back.closest('.level-3-container');
					$level3Container.prev('.level-2').find('> li.sub.opened').removeClass('opened');
					$level3Container.removeClass('opened');
				} else {
					$allLevel2Wrapper.removeClass('opened');
					$allLevel2Wrapper.each((i, el) => {
						$(el).parent('li').removeClass('opened');
					});
				}
			});

			this.$element.find('.level-1 > li.sub > a').on('click', (e) => {
				e.preventDefault();
				const $li = $(e.currentTarget).parent('li');
				const $level2Wrapper = $li.find('> .level-2-wrapper');
				const isActive = $li.hasClass('opened');

				// Close other levels
				this.$element.find('.level-1 > li.sub').removeClass('opened');

				if ($window.width() >= MOBILE_BREAKPOINT) {
					$allLevel2Wrapper.not($level2Wrapper).css('display', 'none');
				}

				this.$element.find('.level-3-container').empty();
				this.$element.find('.level-2 > li.sub').removeClass('opened');

				if (isActive) {
					if ($window.width() >= MOBILE_BREAKPOINT) {
						$level2Wrapper.stop(true, false).slideUp(300);
					}

					$li.removeClass('opened');
				} else {
					$li.addClass('opened');

					if ($window.width() >= MOBILE_BREAKPOINT) {
						$level2Wrapper.stop(true, false).slideDown(300);
					}
				}

				if ($window.width() >= MOBILE_BREAKPOINT) {
					if (isActive) {
						$('.menu-main-overlay').stop(true, false).fadeOut(300);
					} else {
						$('.menu-main-overlay').stop(true, false).fadeIn(300);
					}

					const $activeLevel3 = this.$element.find('.level-3 > li.act');

					if ($activeLevel3.length) {
						this.$element.find('.level-3-container').html($activeLevel3.closest('.level-3-wrapper').find('> .row').clone());
						$activeLevel3.closest('.level-2').find('> li.act').addClass('opened');

						if (!$li.hasClass('act')) {
							this.$element.find('.level-3-container').empty();
							$activeLevel3.closest('.level-2').find('> li.act').removeClass('opened');
						}
					}
				}
			});

			this.$element.find('.level-2 > li.sub > a').on('click', (e) => {
				e.preventDefault();
				const $a = $(e.currentTarget);
				const $li = $a.parent('li');
				const $level3Container = $a.closest('.level-2').next('.level-3-container');
				const isActive = $li.hasClass('opened');

				if (isActive) {
					$li.removeClass('opened');
					$level3Container.empty();
				} else {
					this.$element.find('.level-2 > li.sub.opened').removeClass('opened');
					$li.addClass('opened');
					$level3Container.html($a.next('.level-3-wrapper').find('> .row').clone());

					if ($window.width() < MOBILE_BREAKPOINT) {
						const $arrow = $level3Container.find(Selector.BACK).find('i').clone();
						$level3Container.find(Selector.BACK).html($a.closest('.level-1').find('> li.sub.opened > a').text().trim());
						$level3Container.find(Selector.BACK).prepend($arrow);
					}
				}

				if ($window.width() < MOBILE_BREAKPOINT) {
					if (isActive) {
						$level3Container.removeClass('opened');
					} else {
						$level3Container.addClass('opened');
					}
				}
			});

			this.$element.find('#toggle-menu-main').on('change', (e) => {
				this.$element.find('.level-1-wrapper').toggleClass('opened', e.currentTarget.checked);
			});

			$('.menu-main-overlay').on('click', () => {
				if ($window.width() >= MOBILE_BREAKPOINT) {
					this.$element.find('.level-1 > li.opened > .level-2-wrapper').stop(true, false).slideUp(300);
					$('.menu-main-overlay').fadeOut(300);
					this.$element.find('.level-3-container').empty();
					this.$element.find('li.opened').removeClass('opened');
				}
			});
		}

	}

	return NavMain._getElement($body.find(Selector.NAV_MAIN), NavMain);
})();

export default NavMain;
